import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const getNationalFormatPhoneNumber = (phone: string) => {
  const parsedPhoneNumber = parsePhoneNumberFromString(phone);

  if (!parsedPhoneNumber) {
    return phone;
  }

  return parsedPhoneNumber.formatNational();
};
